export default __webpack_public_path__ + "static/media/BLR1.d4bb4f53.jpg";